import Vue from "vue";
import camelCase from 'lodash/camelCase';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { getEnvironment } from "@/utils/env";

const clientSideIDs = {
	'development': '639b39a3e218991128e5302a',
	'staging': '639b397b40d2b310e6ef075f',
	'production': '639b382e1fc685111984a30e'
}

const formatFlags = (flags) => Object.fromEntries(
  Object.keys(flags).map((key) => [camelCase(key), flags[key]])
);

const rethrow = (e) => {
// Intended to be mocked in tests to avoid uncaught promise rejections in dependencies
  throw e;
};

Vue.use({
  async install(vue, options) {
    const {
      clientSideId,
      user,
      options: ldOptions,
      flagsStub,
      readyBeforeIdentify = true,
    } = options;

    let $ld;

    if (flagsStub) {
      $ld = this.stub({ flagsStub, readyBeforeIdentify });
    } else {
      $ld = this.initialize({ clientSideId, user, ldOptions, readyBeforeIdentify });
    }

    vue.prototype.$ld = $ld;
  },
  initialize  ({ clientSideId, user, ldOptions, readyBeforeIdentify }) {
    user || (user = { key: clientSideId });
    const ldClient = LDClient.initialize(clientSideId, user, ldOptions);
    const $ld = {
      ldClient,
      identify({ newUser, hash, callback }) {
        return new Promise((resolve) => {
          this.ready = false;
          ldClient.identify(newUser, hash, callback).then(() => {
            this.ready = true;
            resolve();
          });
        });
      },
      flags: {},
      ready: false,
      error: null,
    };

    ldClient.on('ready', () => {
      $ld.flags = formatFlags(ldClient.allFlags());
      $ld.ready = readyBeforeIdentify;
    });

    ldClient.on('change', (changes) => {
      const flattenedFlags = Object.fromEntries(
        Object.keys(changes).map((key) => [key, changes[key].current])
      );

      $ld.flags = {
        ...$ld.flags,
        ...formatFlags(flattenedFlags),
      };
    });

    ldClient.on('error', (e) => {
      $ld.error = e;
      rethrow(e);
    });

    return $ld;
  },
  stub ({ flagsStub, readyBeforeIdentify }) {
    return {
      identify() {
        this.ready = true;
      },
      flags: flagsStub,
      ready: readyBeforeIdentify,
    }
  }

}, {
  clientSideId: clientSideIDs[getEnvironment()]
});